import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Button } from '@mui/material';

import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    className?: string;
}

const UpgradeLicense: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);

    return (
        <div className={cx(classes.root, className)}>
            <img width={72} height={72} src={Utils.getImage('logo_small')} alt="logo" />
            <p className={classes.title}>{'Search by product available with subscription'}</p>
            <Button disableRipple size="large" variant="contained" className={classes.button} onClick={goToUserInfo}>
                <>
                    <ArrowUpwardIcon className={classes.icon} />
                    {'Upgrade'}
                </>
            </Button>
        </div>
    );
};

export default React.memo(UpgradeLicense);
